import { render, staticRenderFns } from "./gdot.vue?vue&type=template&id=1145fd9a&scoped=true&"
import script from "./gdot.ts?vue&type=script&lang=ts&"
export * from "./gdot.ts?vue&type=script&lang=ts&"
import style0 from "./gdot.scss?vue&type=style&index=0&id=1145fd9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1145fd9a",
  null
  
)

export default component.exports